import axios from 'axios';
import qs from 'qs';

import { handlePostInquiryMail } from '@component_path/lib/call_api/inquiry_mail/handlePostInquiryMail';

const queryParams = (inquiryMail, authenticityToken, grecaptchaResponse) => {
  const newInquiryMail = Object.assign({}, inquiryMail)
  Object.keys(newInquiryMail).forEach((key) => {
    const value = newInquiryMail[key];
    if (value == null) {
      delete newInquiryMail[key];
    }
  })
  return qs.stringify(
    { db_inquiry_mail: newInquiryMail, authenticity_token: authenticityToken, 'g-recaptcha-response': grecaptchaResponse },
    { arrayFormat: 'brackets' }
  )
}

const sendPositionInquiryMail = async (inquiryMail, authenticityToken, inquiryUrl, grecaptchaResponse = null) => {
  const postParams = queryParams(inquiryMail, authenticityToken, grecaptchaResponse);
  return await handlePostInquiryMail({
    inquiryUrl: inquiryUrl,
    requestBody: postParams,
    resolve: (response) => response,
    reject: (error) => error.response
  });
}

export default sendPositionInquiryMail;